import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import NotificationDetail from './NotificationDetail';

class NewNotificationModal extends React.Component {
    state = {
        showNewNoti: false,
    };

    handleShowNewNoti = () => {
        this.setState({ showNewNoti: true });
    }

    finished = () => {
        this.setState({ showNewNoti: false }, this.props.onClose);
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth='md'
            >
                <DialogTitle id="alert-dialog-title">{'New Notification'}</DialogTitle>
                <DialogContent>
                    {this.state.showNewNoti === true ?
                        <NotificationDetail
                            isNew={true}
                            notify={this.props.notify}
                            resource={this.props.resource}
                            finished={this.finished}
                        />
                        :
                        <DialogContentText id="alert-dialog-description">
                            {'Do you want to notify the updates of the published resources?'}
                        </DialogContentText>
                    }
                </DialogContent>
                {this.state.showNewNoti === false &&
                    <DialogActions>
                        <Button data-id="new-noti-modal-no-btn" onClick={this.props.onClose} color="primary">
                            {'No'}
                        </Button>
                        <Button data-id="new-noti-modal-yes-btn" onClick={this.handleShowNewNoti} color="primary" autoFocus>
                            {'Yes'}
                        </Button>
                    </DialogActions>
                }
            </Dialog>
        );
    }
}
NewNotificationModal.propTypes = {
    resource: PropTypes.object,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    notify: PropTypes.func.isRequired,
};

export default NewNotificationModal;